module.exports = __webpack_public_path__ + "static/media/cd9be43f03f852fd5370d16f67f9048.b263d280.jpg";